import { useForm } from 'react-hook-form';

import { MESSAGES } from '@/constants/messages';
import { OTPFormFields } from '@/types/common';
import showToast from '@/utils/toast';
import { useState } from 'react';

export default function useOtpForm() {
  const [hasFailedOnce, setHasFailedOnce] = useState(false);
  const formMethods = useForm<OTPFormFields>({
    defaultValues: {
      code: '',
    },
    mode: 'onBlur',
  });

  const handleSubmitError = (isServerError?: boolean) => {
    showToast({
      type: 'error',
      data: {
        content: isServerError ? MESSAGES.genericError : 'Invalid OTP code',
      },
    });
  };

  const handleResendError = (isServerError?: boolean) => {
    showToast({
      type: 'error',
      data: {
        content: isServerError
          ? MESSAGES.genericError
          : 'Failed to resend an OTP code',
      },
    });
  };

  const submitForm = (onSubmit: (data: OTPFormFields) => Promise<void>) => {
    const currentValue = formMethods.getValues();
    if (currentValue.code.length === 6) {
      formMethods.handleSubmit(data => onSubmit(data))();
    }
  };

  return {
    formMethods,
    handleSubmitError,
    handleResendError,
    hasFailedOnce,
    setHasFailedOnce,
    submitForm,
  };
}
